import { useEffect } from "react";
import "./DSInfoContainer.css";
import { useSelector, useDispatch } from "react-redux";
import {
  handleCustomizeStructure,
  handleRoofType,
  handleStructure,
} from "./DSFunction";
import { roofType } from "./structureFunction";
import { updateQuantityInfo } from "../../../Features/quantityInfo";
import RoofAccordion from "./Accordion/roofAccordion";
import ObstacleAccordion from "./Accordion/obstacleAccordion";
import SmithStructure from "./customizeOption/smithStructure";
import CustomizeStructure from "./customizeOption/customizeStructure";

export default function DSInfoContainer({ emptyValues }) {
  const dispatch = useDispatch();
  const roofInfo = useSelector((state) => state.roof);
  const gridInfo = useSelector((state) => state.grid);
  const quantityInfo = useSelector((state) => state.quantity);
  const designParameter = useSelector((state) => state.designParameter);

  const roofData = quantityInfo.roofData;
  const roofIndex = quantityInfo.roofNo;
  const roofDetail = roofData.length > 0 ? roofData[roofIndex] : [];

  useEffect(() => {
    dispatch(updateQuantityInfo({ allRoof: false }));
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <div className="ds-InfoContainer">
        <h1>Select Roof & Obstacles</h1>
        <RoofAccordion></RoofAccordion>
        <ObstacleAccordion></ObstacleAccordion>

        {roofData.length > 0 ? (
          <>
            <div className="selectionButton customizeOption">
              <div className="structureBtn">
                <button
                  onClick={() =>
                    handleCustomizeStructure(
                      "smith",
                      dispatch,
                      roofIndex,
                      roofDetail
                    )
                  }
                  style={{
                    backgroundColor: roofDetail.customizeStructure
                      ? "#072a4066"
                      : "#ff7f1e",
                  }}
                >
                  Smith Structure
                </button>
              </div>
              <div className="structureBtn">
                <button
                  onClick={() =>
                    handleCustomizeStructure(
                      "custom",
                      dispatch,
                      roofIndex,
                      roofDetail
                    )
                  }
                  style={{
                    backgroundColor: roofDetail.customizeStructure
                      ? "#ff7f1e"
                      : "#072a4066",
                  }}
                >
                  Customized Structure
                </button>
              </div>
            </div>
            <h1>Select Roof Type</h1>
            <div className="roofContainer">
              {roofType.map((item, i) => (
                <div
                  key={i}
                  className={
                    roofDetail.roofType === item.roofType
                      ? "roofBox roofActive"
                      : "roofBox roofBoxD"
                  }
                  onClick={() => {
                    handleRoofType(item, dispatch, roofIndex);
                  }}
                >
                  <img src={item.roofImage} alt={item.roofType} />
                  <h2>{item.roofType}</h2>
                </div>
              ))}
            </div>
            {roofDetail.roofType !== "Select" &&
              (roofDetail.customizeStructure ? (
                <CustomizeStructure
                  emptyValues={emptyValues}
                ></CustomizeStructure>
              ) : (
                <SmithStructure emptyValues={emptyValues}></SmithStructure>
              ))}
            <div className="updateContainer">
              <div
                className="updateButton"
                onClick={() => {
                  if (
                    !roofDetail.customizeStructure &&
                    roofDetail.mountingStructure === "Select"
                  ) {
                    alert("first of all select any type of mounting structure");
                  } else {
                    handleStructure({
                      dispatch,
                      roofInfo,
                      gridInfo,
                      quantityInfo,
                      roofDetail,
                      designParameter,
                    });
                  }
                }}
              >
                Apply
              </div>
            </div>
          </>
        ) : (
          <>
            <h1>Select Roof Type</h1>
            <div className="roofContainer">
              {roofType.map((item, i) => (
                <div
                  key={i}
                  className={"roofBox"}
                  onClick={() => {
                    alert("First of all draw any roof then select a Roof Type");
                  }}
                >
                  <img src={item.roofImage} alt={item.roofType} />
                  <h2>{item.roofType}</h2>
                  <div className="disable"></div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </>
  );
}
